<template>
  <div>
    <div class="contentBox">
      <div class="headerText">
        <span class="el-icon-warning-outline"></span>
        {{ imgTitle }}
      </div>
      <div style="text-align: right; margin: 20px 0 20px 0">
        <el-button type="primary" size="small" icon="el-icon-check" @click="handleCheckAllChange">全选</el-button>
        <el-button class="orange-btn" size="small" icon="el-icon-download" @click="download">下载</el-button>
      </div>
      <!-- <el-checkbox-group v-model="checkedCities" @change="checkChange">
        <el-checkbox
          v-for="(item,index) in imgList.fileList"
          :label="item"
          :key="item.filePath"
          :style="`width: 32%; height: calc(50% - 10px);overflow:hidden; margin:${index == 1 || index%3 == 1 ? '0px 10px 10px 10px' : '0px 0px 10px 0px'}`"
        >
          <div><strong>{{ item.fileName }}</strong></div>
          <div class="checkBox">
            <video
              style="width: 100%; height: 100%"
              :src="item.filePaths[0].filePath"
              controls
            ></video>
          </div>
          <div style="padding: 10px 0" v-if="item.downloadedStores.length">
            <span class="text" v-for="data in item.downloadedStores" :key="data"> <i class="el-icon-check"></i>{{data}}已下载</span>
            <el-popover
              placement="bottom"
              title=""
              width="100px"
              popper-class="my-popover"
              trigger="hover"
            >
              <div class="popoverBox" v-for="list in item.downloadedStores.slice(3)" :key="list">
                <span class="popperText"><i class="el-icon-check"></i>{{list}}已下载</span>
              </div>
              <div slot="reference" class="popoverText" v-if="item.downloadedStores.length > 3">
                <i class="el-icon-more"></i>
              </div>
            </el-popover>
          </div>
        </el-checkbox>
      </el-checkbox-group> -->
      <div class="imgBox">
        <el-checkbox-group v-model="checkedCities" @change="checkChange">
          <div style="display: flex; flex-wrap: wrap">
            <div
              v-for="(item, index) in vdieoList.fileList.slice((this.pageNum - 1) * this.pageSize, this.pageSize * this.pageNum)"
              :key="item.filePath"
              :style="`width: 32%; height: calc(50% - 10px);overflow:hidden; margin:${
                index == 1 || index % 3 == 1 ? '0px 10px 10px 10px' : '0px 0px 10px 0px'
              }`"
            >
              <div class="checkbox-item">
                <el-checkbox :label="item">
                  <strong v-if="item.fileName && item.fileName.length < 25">{{ item.fileName }}</strong>
                  <el-tooltip class="item" effect="dark" :content="item.fileName" placement="top">
                    <strong v-if="item.fileName && item.fileName.length >= 25">{{ item.fileName }}</strong>
                  </el-tooltip>
                </el-checkbox>
              </div>
              <div class="checkBox">
                <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="item.path"> </video-player>
              </div>
              <div style="padding: 10px 0; line-height: 24px" v-if="item.downloadedStores.length">
                <span class="text" v-for="data in item.downloadedStores.slice(0, 3)" :key="data"> <i class="el-icon-check"></i>{{ data }}已下载</span>
                <el-popover placement="bottom" title="" width="100px" popper-class="my-popover" trigger="click">
                  <div class="popoverBox" v-for="list in item.downloadedStores.slice(3)" :key="list">
                    <i class="el-icon-check"></i>
                    <span class="popperText">{{ list }}已下载</span>
                  </div>
                  <div slot="reference" class="popoverText" v-if="item.downloadedStores.length > 3">
                    <span class="el-icon-more"></span>
                  </div>
                </el-popover>
              </div>
              <div style="height: 49px" v-else></div>
            </div>
          </div>
        </el-checkbox-group>
      </div>
    </div>
    <v-dialog v-model="dialogVisibleDownload" :config="{ showButton: false, width: '400px', title: '视频比例' }">
      <div slot="content">
        <el-form ref="downloadForm" :model="downloadForm" :rules="rules" label-width="60px">
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item label="尺寸:" prop="size">
                <el-checkbox-group v-model="downloadForm.size" @change="handleCheckList">
                  <div v-for="item in imgList.sizeList" :key="item">
                    <el-checkbox :label="item" v-if="item">{{ item }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="text-align: right">
          <el-button @click="dialogVisibleDownload = false">取消</el-button>
          <el-button type="primary" @click="downloadConfirm()">确认</el-button>
        </div>
      </div>
    </v-dialog>
    <div height="auto" style="text-align: right; margin-top: 10px">
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { Checkbox } from "element-ui";
import JSZip, { forEach } from "jszip";
import FileSaver from "file-saver";
export default {
  props: {
    imgList: {
      type: Object,
      default: () => {},
    },
    imgForm: {
      type: Object,
      default: () => {},
    },
    storeCode: {
      type: String,
      default: () => "",
    },
    imgTitle: {
      type: String,
      default: () => "",
    },
  },
  watch: {
    imgList(ov, nv) {
      console.log(ov);
    },
  },
  computed: {
    vdieoList() {
      let vdieoList = JSON.parse(JSON.stringify(this.imgList));
      vdieoList.fileList.forEach((v) => {
        v.path = {
          playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: "zh-CN",
          // aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
            {
              type: "video/mp4",
              src: v.filePaths[0].filePath,
            },
            // {
            //   type: 'application/x-mpegURL',
            //   src: this.playUrl
          ],
          poster: "", //你的封面地址
          // width: document.documentElement.clientWidth,
          notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true, //全屏按钮
          },
        };
      });
      return vdieoList;
    },
  },
  created() {
    this.total = this.imgList && this.imgList.fileList ? this.imgList.fileList.length : 0;
  },
  data() {
    return {
      loading: false,
      dialogImageUrl: "",
      dialogVisible: false,
      checkedCities: [],
      checkAll: false,
      checkAllIndex: 1,
      dialogVisibleDownload: false,
      downloadForm: {
        size: [],
      },
      rules: {
        size: [{ required: true, message: "请选择后在进行下载", trigger: "blur" }],
      },
      sizeDownloadList: [],
      filePathList: [],
      errorNum: 0,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      // vdieoList: [],
    };
  },
  watch: {
    dialogVisibleDownload(val) {
      if (val == false) {
        this.$nextTick((_) => {
          this.$refs["downloadForm"].clearValidate();
        });
        this.addDialogVisible = val;
        this.downloadForm.size = [];
      }
    },
  },
  methods: {
    isVideo(str) {
      return str.search("mp4") != -1 || str.search("avi") != -1;
    },
    handleCheckAllChange() {
      this.checkAllIndex += 1;
      if (this.checkAllIndex % 2 == 0 && this.checkAll != true) {
        this.checkAll = true;
        this.checkedCities = this.vdieoList.fileList;
      } else {
        this.checkedCities = [];
        this.checkAll = false;
      }
    },
    checkChange(val) {
      if (val.length == this.vdieoList.fileList.length) {
        this.checkAllIndex += 1;
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    download() {
      if (!this.checkedCities.length) {
        this.$message.error("请选择对应文件后在进行操作");
        return;
      }
      this.dialogVisibleDownload = true;
    },

    onSizeChange(pageSize) {
      this.pageNum = 1;
      this.pageSize = pageSize;
    },

    onCurrentChange(pageNum) {
      this.pageNum = pageNum;
    },

    downloadConfirm() {
      let _this = this;
      this.$refs["downloadForm"].validate((valid) => {
        if (valid) {
          let data = {
            practicalFileName: this.checkedCities.map((v) => v.practicalFileName),
            videoScale: this.downloadForm.size,
            videoType: this.imgForm.videoType,
            ...this.imgForm,
            storeCode: this.storeCode,
          };
          this.loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.$q.shortVideoOverview.videoDownloadv2({ data: data }).then((res) => {
            if (res.code == 200) {
              var timer = setInterval(function () {
                _this.$q.common.reportTaskInfo({ fragment: [res.message] }).then((res) => {
                  if(res.data.taskResult == "失败") {
                    clearInterval(timer);
                    _this.$message.error(res.data.failReason);
                    _this.loading.close();
                    return
                  }
                  if (res.data.taskStatus == "执行完成") {
                    clearInterval(timer);
                    let filePath = JSON.parse(res.data.filePath);
                    console.log(filePath);
                    let index = 0;
                    let blob = _this.downloadResBlob(filePath[0].filePath);
                    var new_zip = new JSZip();
                    if (filePath[0].fileNum < 5) {
                      new_zip.loadAsync(blob).then((zip) => {
                        //压缩包内文件小于五个就自动解压下载 反之直接下载压缩包
                        for (let key in zip.files) {
                          // 用blob的格式读取，方便后面下载到本地
                          if (key != "/") {
                            let base = zip.file(key).async("blob");
                            base.then((res) => {
                              index++;
                              _this.blobDownload(res, zip.files[key].name);
                              if (filePath[0].fileNum == index) {
                                _this.loading.close();
                                _this.dialogVisibleDownload = false;
                                _this.$message.success("下载成功");
                              }
                            });
                          }
                        }
                      });
                    } else {
                      window.open(filePath[0].filePath, "_self");
                      _this.loading.close();
                      _this.dialogVisibleDownload = false;
                      _this.$message.success("下载成功");
                    }
                  }
                });
                // .catch((err) => {
                //   this.$message.error(err.message);
                // });
              }, 5000);
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    async downloadRes(url, fileName, index) {
      let response = await fetch(url, { mode: "cors" });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName + "" + url.substring(url.lastIndexOf("."));
      a.click();
      a.remove();
    },
    async downloadResBlob(url, fileName) {
      let response = await fetch(url, { mode: "cors" });
      let blob = await response.blob();
      return blob;
    },
    handleCheckList(val) {
      console.log(this.downloadForm.size);
    },
  },
};
</script>

<style lang="stylus" scoped>
.headerText {
  height: auto;
  background: #fff6f3;
  color: #ff8900;
  border-radius: 4px;
  line-height: 28px;
  padding: 5px 10px;
  font-family: PingFangSC;
}

.checkBox {
  width: 100%;
  height: 149px;
  margin: 10px 10px 0 0;
  overflow: hidden;
  border-radius: 6px;
}

// .contentBox >>> .el-checkbox-group {
// display: flex;
// flex-wrap: wrap;
// // justify-content: space-between;
// }

// // .contentBox >>> .el-checkbox {
// //   margin-right: 0 !important;
// // }

// .contentBox >>> .el-checkbox__label {
// width: 100%;
// float: left;
// padding: 0;
// }

// .contentBox >>> .el-checkbox__inner {
// top: 18px;
// }
form >>> .el-form-item {
  display: flex;
  align-items: center;
}

form >>> .el-form-item__content {
  margin-left: 10px !important;
}

strong {
  color: #333333;
  font-weight: 500;
  font-family: PingFangBold;
}

.borderShow {
  border: 2px solid #0BB78E;
}

.el-icon-check {
  color: #0BB78E !important;
}

.text {
  color: #999999 !important;
  font-family: PingFangSC;
  font-size: 13px;

  &::after {
    content: '';
    margin-right: 10px;
  }
}

.el-icon-more {
  line-height: 24px;
  font-size: 13px;
  color: #666666;
}

.popperText {
  color: #666666;
  font-family: PingFangSC;
  font-size: 13px;
  font-weight: 400;

  &::before {
    content: '';
    margin-left: 5px;
  }
}

.popoverText {
  display: inline-block;
  background: #F4F4F4;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  opacity: 0.8;
  line-height: 24px;
  text-align: center;
  color: #606266 !important;
}

.popoverBox {
  text-align: center;
  padding: 5px 0;
}

>>> .video-player {
  height: 100%;
}

>>> .video-js.vjs-fluid, .video-js.vjs-16-9, .video-js.vjs-4-3 {
  height: 100%;
  padding-top: 0 !important;
}

>>> .vjs-custom-skin > .video-js .vjs-big-play-button {
  font-size: 2em !important;
}
</style>
<style scoped>
@media screen and (min-width: 1920px) {
  /* .contentBox {
    max-height: 630px;
    padding-bottom: 20px;
  } */
  .imgBox {
    max-height: 500px;
    overflow-y: auto;
  }
}

@media screen and (max-width: 1500px) {
  /* .contentBox {
    max-height: 340px;
    padding-bottom: 20px;
  } */
  .imgBox {
    max-height: 235px;
    overflow-y: auto;
  }
}
</style>
